module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_7016.268960ba.png";